import React, { Component } from 'react';

import dataSecurity from '../../../assets/images/security/data-security.svg';
import globe from '../../../assets/images/security/globe.svg';
import onlineWork from '../../../assets/images/security/online-work.svg';
import webDomain from '../../../assets/images/security/web-domain.svg';

export default class SecurityFooter extends Component {
    render() {
        return (
            <div
                className={`${
                    !this.props.onboarding
                        ? this.props.tablet
                            ? 'c-auth-page__security  position-absolute  o-d-none-tablet'
                            : 'c-auth-page__security  o-none-from-tablet'
                        : 'c-auth-page__security c-auth-page__security--onboarding'
                }`}
            >
                <div className="o-flex o-flex-middle">
                    <img
                        width="100%"
                        height="25"
                        src={dataSecurity}
                        alt="imageAWS"
                    />
                    <h5 className="font-450 font-family-secondary font-14 font-333 opacity-9 margin-reset">
                        Gold Standard Data Storage
                    </h5>
                </div>
                <div className="o-flex o-flex-middle">
                    <img width="100%" height="25" src={globe} alt="imageSSL" />
                    <h5 className="font-450 font-family-secondary font-14 font-333 opacity-9 margin-reset">
                        Secure Connection
                    </h5>
                </div>
                <div className="o-flex o-flex-middle">
                    <img
                        width="100%"
                        height="25"
                        src={onlineWork}
                        alt="imageGDPR"
                    />
                    <h5 className="font-450 font-family-secondary font-14 font-333 opacity-9 margin-reset">
                        GDPR Compliance
                    </h5>
                </div>
                <div className="o-flex o-flex-middle">
                    <img
                        width="100%"
                        height="25"
                        src={webDomain}
                        alt="imageDATA"
                    />
                    <h5 className="font-450 font-family-secondary font-14 font-333 opacity-9 margin-reset">
                        Data Encryption
                    </h5>
                </div>
            </div>
        );
    }
}
